import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { RouteResources } from '@atlassian/react-resource-router';
import { MenuIdAddons } from '@jira/navigation-apps__constants/src/MenuIdAddons.tsx';
import { SidebarIdGlobalAppsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalAppsSettings.tsx';
import { getNavigationSidebarGlobalSettingsResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { LegacyEntryRoute } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { RootLifecycleEntryPointContainer } from '@jira/platform__spa/src/view/RootLifecycleEntryPointContainer.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';
import { emceeAppRoute } from '@jira/router-routes__legacy-global-settings-apps-routes/src/emceeAppRoute.tsx';

const emceeAppMigrationEmptyProps = {};
const emceeAppMigrationEntryPoint0 = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-emceeApp-0" */ './EmceeAppRoot.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => emceeAppMigrationEmptyProps,
	},
});

export const emceeAppRouteEntry: LegacyEntryRoute<RouteResources> = createLegacyEntry(
	emceeAppRoute,
	() => ({
		canTransitionIn: () => false,

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_9') ? undefined : LegacyPage,

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalAppsSettings,
			menuId: MenuIdAddons,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			...getNavigationSidebarGlobalSettingsResources(),
		],

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_9') ? emceeAppMigrationEntryPoint0 : undefined,
		entryPointContainer: fg('nike_entrypoint_migration_batch_9')
			? RootLifecycleEntryPointContainer
			: undefined,
	}),
);
